exports.onInitialClientRender = () => {
    require('typeface-open-sans')
    require('typeface-domine')
  }

require("prismjs/themes/prism-tomorrow.css")